import { useEffect, useMemo, useState } from 'react'

import {
  ModelsDocumentModel,
  ConclusionServiceModel
} from '../../../domain/models'
import { fetchConclusionService } from '../../../main/usecases'

import { Checkbox, SelectInput } from '..'

type HasConclusionProps = {
  document?: ModelsDocumentModel
  handleDefaultConclusion: (e: boolean) => void
  handleChangeSelectInput: () => void
}

const HasConclusion = ({
  document,
  handleDefaultConclusion,
  handleChangeSelectInput
}: HasConclusionProps) => {
  const [checked, setChecked] = useState(false)
  const [conclusionToService, setConclusionToService] =
    useState<ConclusionServiceModel[]>()

  const optionsConclusionService = useMemo(
    () =>
      conclusionToService?.map((item) => {
        return {
          value: item?.conclusaoAvaliacao.replace('á', 'a').toUpperCase(),
          label: item?.cdConclusaoAvaliacao
        }
      }),
    [conclusionToService]
  )

  useEffect(() => {
    if (document?.secao?.conclusao !== 'DEFAULT') {
      setChecked(true)
    }
  }, [document?.secao?.conclusao])

  useEffect(() => {
    ;(async () => {
      try {
        const responseToConclusionService =
          await fetchConclusionService().load()
        setConclusionToService(responseToConclusionService)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return (
    <div className="conclusion-container">
      <Checkbox
        labelColor="black"
        labelFor={`conclusion-${document?.secao?.cdSecao}`}
        label="É conclusão?"
        name={`conclusion-${document?.secao?.cdSecao}`}
        isChecked={checked}
        onCheck={(e) => {
          if (e === false) {
            handleDefaultConclusion(e)
            setChecked(false)
          }
          setChecked(e)
        }}
      />
      {checked === true && (
        <div className="select-input-container">
          <SelectInput
            labelColor="#4F4F4F"
            name={`conclusion-${document?.secao?.cdSecao}`}
            hasConclusionInput
            onChange={handleChangeSelectInput}
            value={
              document?.secao?.conclusao === 'DEFAULT'
                ? ''
                : document?.secao?.conclusao
            }
            options={optionsConclusionService}
          />
        </div>
      )}
    </div>
  )
}

export default HasConclusion
